
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import CarNumber from "@/components/CarNumber.vue";
  import {IHome} from "@/modules/Home/interfaces/home.interface";
  import {httpResource} from "@/resources/http.resource";
  import {bus} from "@/plugins/bus";
  import {ICarList} from "@/modules/CarList/interfaces/car-list.interface";
  import {IBook} from "@/interfaces/book.interface";
  import {paymentResource} from "@/modules/Profile/resources/payment.resource";
  import {IProfilePayment} from "@/modules/Profile/interfaces/profile-payment.interface";
  import {IAppState} from "@/interfaces/app-state.interface";
  import {ICar} from "@/modules/Car/interfaces/car.interface";

  @Component({
    components: {
      AppDialog,
      CarNumber,
    },
  })
  export default class FavoriteCarsPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'home', dialogName: 'favoriteCars' };
    favoriteCars = [];
    createdCars = [];
    visibleDropdown = false;
    paymentCars = false;
    paymentCarList = [];

    get storeState(): IAppState { return this.$store.state; }
    get popupPayload() { return this.$refs.appDialog.payloadPopup; }
    get carPopupDisplay() { return this.storeState.car.displayPopup; }
    get bookCars() {
      let bookCars = this.storeState.book.books[IBook.BookName.carsMyCorpForFavorite]
        .map(bookItem => { return { carId: bookItem.id, carNumber: bookItem.name } });
      if (this.paymentCars) {
        bookCars = this.paymentCarList;
      }
      return bookCars;
    }
    get carList() {
      let arrayCars = [...this.bookCars, ...this.createdCars];
      return arrayCars.map(car => {
        return {
          ...car,
          selected: this.favoriteCars.findIndex(item => item.carId === car.carId) > -1,
        };
      }).filter(car => !car.selected);
    }

    async mounted() {
      this.paymentCars = Boolean(this.popupPayload.paymentCars);
      this.favoriteCars = this.popupPayload.favoriteCars.map(car => { return { carId: car.carId, carNumber: car.carNumber }; });

      await this.updateBooks();

      bus.$on(ICarList.EmitterEvents.CREATE_CAR, async (car: ICar.IEntity) => {
        let newCar = { carId: car.carId, carNumber: car.carNumber };

        let isExistCar = Boolean(this.favoriteCars.find(car => car.carId === newCar.carId));
        this.$notify({
          title: isExistCar ? 'Внимание' : 'Успешно',
          message: isExistCar ? 'Вы попытались создать уже существующий автомобиль' : 'Автомобиль успешно добавлен',
          type: isExistCar ? 'warning' : 'success',
        });
        if (!isExistCar) {
          this.createdCars.push(newCar);
          await this.selectCar(newCar);
        }
      });
    }

    async updateBooks() {
      if (this.paymentCars) {
        let { response: { data: { result: cars } } } = await paymentResource.getFavoriteCars();
        this.paymentCarList = cars.sort((a, b) => a.carNumber < b.carNumber ? -1 : 1);
      }
      else {
        await this.$store.dispatch('book/getBook', {bookNames: [IBook.TableName.carsMyCorpForFavorite], needUpdate: true});
      }
    }

    async addNewCar() {
      await this.$store.dispatch('car/openCarPopup', { carId: null, customCreateNotification: true, });
    }

    async selectCar(car) {
      this.favoriteCars.push({ carId: car.carId, carNumber: car.carNumber });
      this.visibleDropdown = false;
      await this.saveList(car, true);
    }

    async removeCar(index) {
      let car = this.favoriteCars[index];
      this.favoriteCars.splice(index, 1);
      await this.saveList(car);
    }

    async saveList(car, add = false) {
      if (this.paymentCars) {
        await paymentResource.updateCarsPaymentList(car.carId, add);
      }
      else {
        let asyncAction = async () => {
          let action = IHome.Action;
          let params = {command: IHome.Command.Set, favoriteCars: this.favoriteCars};
          await httpResource.httpAction({action, params});
        };
        await this.$store.dispatch('defaultResourceAction', {asyncAction});
      }
    }

    async addAllCars() {
      await paymentResource.addAllCarsToPayment();
      this.favoriteCars = [...this.bookCars];
    }

    async closeAction() {
      bus.$emit(IHome.EmitterEvents.UpdateCarInfo);
      bus.$emit(IProfilePayment.Events.UpdateCountsCarsPayment);
    }

    destroyed() {
      bus.$off(ICarList.EmitterEvents.CREATE_CAR);
    }
  }
